
window.onloadstart= function(){
    var isIE = /*@cc_on!@*/false || !!document.documentMode; 
    if(isIE===true){
        var bodyContainer = document.getElementById('home');
        bodyContainer.innerHTML= "<img style='display: flex; justify-content: center; margin: 0 auto;' src='../assets/style/ckm-style/images/noSupport.png'/>"
    }
}